module.exports = __webpack_public_path__ + "img/jianjie1.2749f861.jpg";